import { usePropertiesGetLocationIds } from '../../../Hooks/usePropertiesGetLocationIds';
import { LocationVarKey } from '@swivl-mono/types';
import {TextRow, Indent, InputRow, TextAreaRow, DropdownRow, MultiLineRow, SwitchRow, SectionHeader, PageHeader } from '../../../Components/Worksheets/WorksheetComponent/WorksheetComponents';
import { IS_NOT_EQUAL, IS_EQUAL, IS_TRUE } from '../../../Components/Worksheets/Types/Worksheet.Interface';

export default  function WorksheetView() {
    const page = usePropertiesGetLocationIds();  
  return  <>
        <PageHeader {...page} 
        subheading=""
        > Custom Call To Action</PageHeader>
        

        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.CTAMessage1}
        />
        <TextAreaRow {...page}  
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.CTAMessage2}
            enableSwitchVar={LocationVarKey.CTAMessage2Enabled}
        />

        <TextAreaRow {...page}  
            marginTop
            label=" Message 3 (Optional)"
            keyName= {LocationVarKey.CTAMessage3}
            enableSwitchVar={LocationVarKey.CTAMessage3Enabled}
        />

        <SwitchRow {...page}  keyName= {LocationVarKey.CTAhasURLNavigateTo} label="Navigate to Url"/>
        <InputRow {...page}  keyName= {LocationVarKey.CTAURLNavigateTo} label="Navigate to URL" hideIf={IS_NOT_EQUAL(LocationVarKey.CTAhasURLNavigateTo,"1")}/>
        <TextAreaRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.CTAhasURLNavigateTo,"1")}
            marginTop
            label=" Menu Message"
            keyName= {LocationVarKey.CTAURLNavigateToMessage1}
        />

    </>
}